<template>
  <div class="bg-[#fff] py-[14] border-[#dadada] border-solid" :class="{ 'border-b-[1px]': border }">
    <div :style="{ width: width }" class="mx-[auto] flex items-center justify-between">
      <div class="flex items-center">
        <i v-if="conf.logoIcon" class="iconfont-logo t-[theme] mr-[5] t-[28]" :class="conf.logoIcon"></i>
        <img v-else class="w-[28] mr-[5]" :src="require(`@/assets/img/city/${conf.city}/logo.png`)" alt="" />

        <span class="t-[20] font-600">{{ conf.name }}</span>
      </div>
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dg-head",
  props: {
    width: {
      type: String,
      default: "1200px",
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>
<style scoped></style>
 <style>.bg-\[\#fff\] {
    background-color: #fff
}
.py-\[14\] {
    padding-top: 14px;
    padding-bottom: 14px
}
.border-\[\#dadada\] {
    border-color: #dadada
}
.border-b-\[1px\] {
    border-bottom-width: 1px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.t-\[theme\] {
    color: #008AA6
}
.mr-\[5\] {
    margin-right: 5px
}
.t-\[28\] {
    font-size: 28px
}
.w-\[28\] {
    width: 28px
}
.t-\[20\] {
    font-size: 20px
}
.border-solid {
    border-style: solid
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}
.justify-between {
    justify-content: space-between
}
.font-600 {
    font-weight: 600
}</style>